import { STYLE } from '@wix/component-protocol/schema';
import {
  StylesDerivedNativeActionNames,
  StylesDerivedNativeActions,
} from '@wix/editor-platform-host-integration-apis';

type CssPropertyType =
  (typeof STYLE.CSS_PROPERTY_TYPE)[keyof typeof STYLE.CSS_PROPERTY_TYPE];

const BORDER_CSS_PROPERTY_TYPES = [
  STYLE.CSS_PROPERTY_TYPE.border,
  STYLE.CSS_PROPERTY_TYPE.borderTop,
  STYLE.CSS_PROPERTY_TYPE.borderBottom,
  STYLE.CSS_PROPERTY_TYPE.borderLeft,
  STYLE.CSS_PROPERTY_TYPE.borderRight,
] as const;

const BORDER_COLOR_CSS_PROPERTY_TYPES = [
  STYLE.CSS_PROPERTY_TYPE.borderColor,
  STYLE.CSS_PROPERTY_TYPE.borderTopColor,
  STYLE.CSS_PROPERTY_TYPE.borderBottomColor,
  STYLE.CSS_PROPERTY_TYPE.borderLeftColor,
  STYLE.CSS_PROPERTY_TYPE.borderRightColor,
] as const;

const BORDER_WIDTH_CSS_PROPERTY_TYPES = [
  STYLE.CSS_PROPERTY_TYPE.borderWidth,
  STYLE.CSS_PROPERTY_TYPE.borderBottomWidth,
  STYLE.CSS_PROPERTY_TYPE.borderLeftWidth,
  STYLE.CSS_PROPERTY_TYPE.borderRightWidth,
  STYLE.CSS_PROPERTY_TYPE.borderTopWidth,
] as const;

const BORDER_STYLE_CSS_PROPERTY_TYPES = [
  STYLE.CSS_PROPERTY_TYPE.borderStyle,
  STYLE.CSS_PROPERTY_TYPE.borderBottomStyle,
  STYLE.CSS_PROPERTY_TYPE.borderLeftStyle,
  STYLE.CSS_PROPERTY_TYPE.borderRightStyle,
  STYLE.CSS_PROPERTY_TYPE.borderTopStyle,
] as const;

export const ALLOWED_CSS_PROPERTY_TYPES_BY_ACTION_NAME = {
  [StylesDerivedNativeActions.globalColorsStyles]: [
    STYLE.CSS_PROPERTY_TYPE.color,
    STYLE.CSS_PROPERTY_TYPE.backgroundColor,
    ...BORDER_COLOR_CSS_PROPERTY_TYPES,
  ],
  [StylesDerivedNativeActions.textStyles]: [
    STYLE.CSS_PROPERTY_TYPE.color,
    STYLE.CSS_PROPERTY_TYPE.fontFamily,
    STYLE.CSS_PROPERTY_TYPE.fontWeight,
    STYLE.CSS_PROPERTY_TYPE.fontSize,
  ],
  [StylesDerivedNativeActions.borderStyles]: [
    ...BORDER_CSS_PROPERTY_TYPES,
    ...BORDER_COLOR_CSS_PROPERTY_TYPES,
    ...BORDER_WIDTH_CSS_PROPERTY_TYPES,
    ...BORDER_STYLE_CSS_PROPERTY_TYPES,
  ],
  [StylesDerivedNativeActions.cornerStyles]: [
    STYLE.CSS_PROPERTY_TYPE.borderTopLeftRadius,
    STYLE.CSS_PROPERTY_TYPE.borderTopRightRadius,
    STYLE.CSS_PROPERTY_TYPE.borderBottomLeftRadius,
    STYLE.CSS_PROPERTY_TYPE.borderBottomRightRadius,
    STYLE.CSS_PROPERTY_TYPE.borderRadius,
  ],
  [StylesDerivedNativeActions.fillStyles]: [
    STYLE.CSS_PROPERTY_TYPE.backgroundImage,
    STYLE.CSS_PROPERTY_TYPE.backgroundColor,
    STYLE.CSS_PROPERTY_TYPE.background,
  ],
  [StylesDerivedNativeActions.shadowStyles]: [
    STYLE.CSS_PROPERTY_TYPE.boxShadow,
  ],
  [StylesDerivedNativeActions.spacingStyles]: [
    STYLE.CSS_PROPERTY_TYPE.padding,
    STYLE.CSS_PROPERTY_TYPE.paddingBottom,
    STYLE.CSS_PROPERTY_TYPE.paddingLeft,
    STYLE.CSS_PROPERTY_TYPE.paddingRight,
    STYLE.CSS_PROPERTY_TYPE.paddingTop,
    STYLE.CSS_PROPERTY_TYPE.gap,
    STYLE.CSS_PROPERTY_TYPE.rowGap,
    STYLE.CSS_PROPERTY_TYPE.columnGap,
  ],
} as const satisfies Record<
  StylesDerivedNativeActionNames,
  readonly CssPropertyType[]
>;
